import { render, staticRenderFns } from "./SimPackageManage.vue?vue&type=template&id=6652fafc"
import script from "./SimPackageManage.vue?vue&type=script&lang=js"
export * from "./SimPackageManage.vue?vue&type=script&lang=js"
import style0 from "./SimPackageManage.vue?vue&type=style&index=0&id=6652fafc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports